module.exports = __webpack_public_path__ + "img/Drache.77ebae15.jpg";